module.exports = "/packs/images/svg/facilities/prayer_room~50c3cb3cdc684d1f43e9f253dabb22f3.svg";